import { render, staticRenderFns } from "./savePlaceList.vue?vue&type=template&id=7f49ee51"
import script from "./savePlaceList.vue?vue&type=script&lang=js"
export * from "./savePlaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports